const urlPath          = window.location.pathname
const isAdminPath      = urlPath.indexOf('/admin') === 0
const isAdminLoginUrl  = urlPath.indexOf('/admin/login') === 0
const isClientPath     = urlPath.indexOf('/client') === 0
const isClientLoginUrl = urlPath.indexOf('/client/login') === 0
const adminTokenName   = 'adminToken'
const clientTokenName  = 'clientToken'

export function getModuleName() {
  if (isAdminPath) {
    return 'admin'
  }

  if (isClientPath) {
    return 'client'
  }

  throw new Error('Path does not contain any recognizable module name!')
}

export function getTokenName() {
  if (isAdminPath) {
    return adminTokenName
  }

  if (isClientPath) {
    return clientTokenName
  }

  throw new Error('Path does not contain any recognizable module name!')
}

export function getToken() {
  return window.localStorage.getItem(getTokenName()) || ''
}

export function isValidPath() {
  return isAdminPath || isClientPath
}

export function initAuthForAxios() {
  if (!isValidPath()) return

  const token = getToken()

  // Supply API with OAuth token if exists
  if (token) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
  }
}

export function handleUnauthorized(error) {
  if (error.response && error.response.status === 401) {
    if (isAdminPath && !isAdminLoginUrl) {
      window.location.href = '/admin/login'
    } else if (isClientPath && !isClientLoginUrl) {
      window.location.href = '/client/login'
    }
  }

  return Promise.reject(error)
}
